import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { Fragment, type ReactNode } from 'react';

import { Footer } from '_components/layout/Footer';
import { Layout, NavigationData } from '_components/layout/Layout';
import { Expertise } from '_core/repos/expertises.repo';
import { Links } from '_types/public-api';

import { rankingConfig } from '../ranking.config';
import { RankingStaticHeader } from './RankingStaticHeader';

interface RankingStaticLayoutProps {
  navigationData: NavigationData;
  homepageLinks: Links | null;
  expertises: Expertise[];
  children: ReactNode;
}

export const RankingStaticLayout = (props: RankingStaticLayoutProps) => {
  const { navigationData, homepageLinks, expertises, children } = props;
  const { t } = useTranslation(rankingConfig.i18nNamespaces);

  return (
    <Layout
      navigationData={navigationData}
      links={homepageLinks ?? undefined}
      expertises={expertises}
      t={t}
      showFooter={false}
      minimalHeader={<RankingStaticHeader navigationData={navigationData} />}
      briefingCTA={<Fragment />}
      comparatorCTA={<Fragment />}
      search={null}
      searchMobile={null}>
      {children}
      <Footer isStatic showRankUpdated navigationData={navigationData} t={t} />
    </Layout>
  );
};
